export default function checkRuls(t) {
  // 选项不为空校验
  const validateEmpt = (rule, modleVal, callback) => {
    if ((!!!modleVal.value && modleVal.value !== 0) || (modleVal.validateType === 'array' && modleVal.value.length === 0)) {
      // 当前项不能为空
      callback(new Error(t('form.emptyErrMsg')))
    } else {
      callback()
    }
  }
  const emptCheck = [
    { required: true },
    { validator: validateEmpt }
  ]
  // URL 地址校验
  const validateUrl = (rule, modelValue, callback) => {
    if (!modelValue.value) {
      callback(new Error(t('form.emptyErrMsg')))
      return
    }
    const trimmedValue = modelValue.value.trim()
    // URL 正则表达式：
    // 支持 http:// 或 https://
    // 域名或 IP
    // 可选端口
    // 可选路径
    const urlPattern = /^https?:\/\/(([\da-z\.-]+)\.([a-z\.]{2,6})|((\d{1,3}\.){3}\d{1,3}))(:\d{1,5})?(\/[\w\.-]+)*\/?$/
    // 检查路径中（排除协议部分的 //）是否有连续的 /
    // 检查末尾是否有多个连续的 /（末尾最多只能有一个 /）
    const hasConsecutiveSlashes = /[^:]\/{2,}/.test(trimmedValue)
    if (!urlPattern.test(trimmedValue) || hasConsecutiveSlashes) {
      callback(new Error(t('form.urlErrMsg')))
    } else {
      callback()
    }
  }
  const urlCheck = [
    { required: true },
    { validator: validateUrl }
  ]

  return {
    emptCheck,
    urlCheck
  }
}